export const UnhandleException = "UnhandleException";

//-- common error
export const ERRORGETAPI = 'ERRORGETAPI';